import { MobileLayout, LayoutType, BlockRef, MetaType } from "../types"
import {
  actionCreatorGuard,
  reducerActions,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "seq_screens"

export type SeqScreen = {
  kind: typeof kind
  version: number
  name: string
  layout: LayoutType
  mobileLayout: MobileLayout
  left: Array<BlockRef>
  right: Array<BlockRef>
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SeqScreen, MetaType>("meta", kind),
  left: actionCreatorGuard<SeqScreen, Array<BlockRef>>("left", kind),
  right: actionCreatorGuard<SeqScreen, Array<BlockRef>>("right", kind),
  layout: actionCreatorGuard<SeqScreen, LayoutType>("layout", kind),
  mobileLayout: actionCreatorGuard<SeqScreen, MobileLayout>(
    "mobileLayout",
    kind
  ),
  name: actionCreatorGuard<SeqScreen, string>("name", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SeqScreen,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const seqScreenAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const seqScreenReducer = reducerGuard<SeqScreen>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.left)
  .case(...reducerAction.right)
  .case(...reducerAction.layout)
  .case(...reducerAction.mobileLayout)
  .case(...reducerAction.name)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "left":
        return getArrayReducerGuard<SeqScreen, BlockRef>(
          kind,
          "left",
          "BlockRef",
          prevState,
          action
        )
      case "right":
        return getArrayReducerGuard<SeqScreen, BlockRef>(
          kind,
          "right",
          "BlockRef",
          prevState,
          action
        )
    }

    return prevState
  })
